export default __webpack_public_path__ + "static/media/incompletestep.36c524ed.svg";